import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

export function timezoneInterceptor(
    req: HttpRequest<unknown>,
    next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
    return next(
        req.clone({
            setHeaders: {
                'X-Timezone': timeZone,
            },
        }),
    );
}
